import { IconInfoFilled, IconWarningFilled, IconAlertFilled, IconRewardFilled, IconCheck } from '@hubble/icons';
import { jsx } from '@emotion/react/jsx-runtime';

const EMPTY_STATE_DEFAULT_ICONS = {
  informational: jsx(IconInfoFilled, {}),
  warning: jsx(IconWarningFilled, {}),
  negative: jsx(IconAlertFilled, {}),
  reward: jsx(IconRewardFilled, {}),
  neutral: jsx(IconInfoFilled, {}),
  positive: jsx(IconCheck, {})
};

export { EMPTY_STATE_DEFAULT_ICONS };
